<template>
  <div class="fondovista">    
    <div class="container">
      <transition name="slide-fade" appear>
        <b-card>
          <h3 class="mt-2"><b-icon-person-fill></b-icon-person-fill> Perfil del Usuario</h3><hr class="mt-1">
          <b-card-text>
            <b-card>
              <div slot="header"><strong> Datos del Usuario</strong></div>
              <b-card-text>
                <b-form @submit.stop.prevent>
                  <b-row>
                    <b-col md="4">
                      <b-form-group class="small" label="Nombres: *" label-for="nombres">
                        <b-form-input type="text" size="sm" id="nombres" v-model="datosUsuario.nombres" placeholder="Nombres del Usuario" autofocus></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group class="small" label="Apellidos: *" label-for="apellidos">
                        <b-form-input type="text" size="sm" id="apellidos" v-model="datosUsuario.apellidos" placeholder="Apellidos del Usuario"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group class="small" label="Nacionalidad: *" label-for="nacionalidad">
                        <b-form-select size="sm" id="nacionalidad" v-model="datosUsuario.id_nacionalidad" :options="nacionalidades" @change="cambioPais"></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4">
                      <b-form-group class="small" label="No. Documento: *" label-for="documento">
                        <b-form-input type="text" size="sm" id="documento" v-model="datosUsuario.documento" placeholder="No. Documento de Identificación"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group class="small" label="Tipo Documento: *" label-for="tipo">
                        <b-form-select size="sm" id="tipo" v-model="datosUsuario.id_documento" :options="documentos"></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group class="small" label="Expedido en:" label-for="expedido">
                        <b-form-select v-if="datosUsuario.id_nacionalidad" size="sm" id="expedido" v-model="datosUsuario.id_municipio_documento" :options="municipios" @change="cambioMunicipioExpedido"></b-form-select>
                        <b-form-input type="text" v-else size="sm" id="expedido" v-model="datosUsuario.municipio_documento" placeholder="Municipio de Expedición"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4">
                      <b-form-group class="small" label="Pais Origen:" label-for="pais">
                        <b-form-input type="text" v-if="datosUsuario.id_nacionalidad" size="sm" id="pais" v-model="datosUsuario.pais" disabled></b-form-input>
                        <b-form-input type="text" v-else size="sm" id="pais" v-model="datosUsuario.pais" placeholder="País de Origen"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group class="small" label="Fecha Nacimiento:" label-for="fechanace">
                        <b-form-input type="date" size="sm" id="fechanace" v-model="datosUsuario.fecha_nacimiento" placeholder="Fecha Nacimiento"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="2">
                      <b-form-group class="small" label="Genero: *" label-for="genero">
                        <b-form-select size="sm" id="genero" v-model="datosUsuario.id_genero" :options="generos"></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col md="2">
                      <b-form-group class="small" label="Rh: *" label-for="rh">
                        <b-form-select size="sm" id="rh" v-model="datosUsuario.id_rh" :options="rhs"></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="8">
                      <b-form-group class="small" label="Dirección de Residencia:" label-for="direccion">
                        <b-form-input type="text" size="sm" id="direccion" v-model="datosUsuario.direccion" placeholder="Dirección de Residencia"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group class="small" label="Municipio Residencia:" label-for="municipiodireccion">
                        <b-form-select size="sm" id="municipiodireccion" v-model="datosUsuario.id_municipio_direccion" :options="municipios"></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4">
                      <b-form-group class="small" label="Teléfono 1:" label-for="telefono1">
                        <b-form-input type="text" size="sm" id="telefono1" v-model="datosUsuario.telefono1" placeholder="Teléfono 1"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group class="small" label="Teléfono 2:" label-for="telefono2">
                        <b-form-input type="text" size="sm" id="telefono2" v-model="datosUsuario.telefono2" placeholder="Teléfono 2"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group class="small" label="Correo Electrónico: *" label-for="correo">
                        <b-form-input type="mail" size="sm" id="correo" v-model="datosUsuario.correo" placeholder="Correo Electrónico" required></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-button variant="primary" @click="actualizarDatos()">Actualizar</b-button>
                  <b-button variant="danger">Reset</b-button>
                </b-form>              
              </b-card-text>
            </b-card>
          </b-card-text>
          <b-card class="mt-3" header="Resultados">
            <pre class="m-0">{{ datosUsuario }} {{datosSesion}}</pre>
          </b-card>
        </b-card>
      </transition>
    </div>
  </div>
</template>
<script>
  import axios from "axios"
  import * as CONFIG from '@/assets/config.js'
  import {mapState, mapMutations} from 'vuex'
  import listaMunicipios from "@/assets/tablas/listaMunicipios.js";
  import listaDocumentos from "@/assets/tablas/listaDocumentos.js";
  import listaGeneros from "@/assets/tablas/listaGeneros.js";
  import listaRhs from "@/assets/tablas/listaRhs.js";

  export default {
    data() {
      return {
        datosUsuario: {},
        nacionalidades: [{value: 1, text: 'Colombia'},{value: 0,text: 'Otra'}],
        municipios: [],
        documentos: [],
        generos: [],
        rhs: []
      }
    },
    methods: {
      async cargarDatos() {
        await axios
        .get(CONFIG.ROOT_PATH + "usuarios/" + this.datosSesion.idUsuario)
        .then(response => {
          if (response.data.error){
            this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
          } else{
            this.datosUsuario = response.data.datos
            console.log('Perfil: ' + JSON.stringify(response.data.datos))
            this.datosUsuario.fecha_nacimiento = response.data.datos.fecha_nacimiento.slice(0, 10)
          }
        })
        .catch(err => {
          if (err.message === "Network Error")
            this.mensajeEmergente("danger","Mensaje","Conexión denegada!. Por favor contáctese con el administrador.");
          else
            this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor contáctese con el administrador." + err.message);
        });
      },
      async actualizarDatos() {
        await axios
        .put(CONFIG.ROOT_PATH + "usuarios/" + this.datosSesion.idUsuario,JSON.stringify(this.datosUsuario),{ headers: {"Content-Type": "application/json; charset=utf-8" }})
        .then(response => {
          if (response.data.error){
            this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
          } else{
            this.mensajeEmergente("success","Mensaje",response.data.mensaje)
          }
        })
      },
      cambioPais() {
        if (this.datosUsuario.id_nacionalidad) {
          this.datosUsuario.pais = 'Colombia'
          this.datosUsuario.municipio_documento = ''
          this.datosUsuario.id_municipio_documento = null
        } else {
          this.datosUsuario.pais = ''
          this.datosUsuario.municipio_documento = ''
          this.datosUsuario.id_municipio_documento = null
        }
      },
      cambioMunicipioExpedido() {
        this.datosUsuario.municipio_documento = document.getElementById("expedido").options[document.getElementById("expedido").selectedIndex].text
      },
      mensajeEmergente(variante, titulo, contenido) {
        this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false });
      }
    },
    beforeMount() {
      this.municipios = listaMunicipios
      this.documentos = listaDocumentos
      this.generos = listaGeneros
      this.rhs = listaRhs
      this.cargarDatos()
    },
    computed: {
      ...mapState(['datosSesion'])
    }
  }
</script>